<template functional>
  <div class="list__item__title">
    <slot>{{ data.domProps && data.domProps.textContent }}</slot>
  </div>
</template>

<script>
export default {
  name: 'b2b-list-item-title',
};
</script>

<style lang="scss">
.list__item__title {
  font-size: 1rem;
  line-height: 1.2;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
